import { useState } from "react";
import { Button, Table } from "react-bootstrap";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import Loader from "../../common/Loader";
import NoData from "../../common/NoData";
import Pagination from "../../common/Pagination/Pagination";
import { Translate } from "../../Enums/Tranlate";
import CardItem from "./CardItem";
import ZoneService from "../../../services/ZoneService";
import { usePermissions } from "../../common/permissions";

const Zones = () => {
	const [admins, setAdmins] = useState(null);
	const [hasData, setHasData] = useState(null);
	const [shouldUpdate, setShouldUpdate] = useState(false);
	const [loading, setLoading] = useState(false);
	const navigate = useNavigate();
	const zoneService = new ZoneService();
	const Auth = useSelector((state) => state.auth?.auth);
	const { canAdd } = usePermissions();
	const lang = useSelector((state) => state.auth?.lang);
	const search = useSelector((state) => state.auth.search);

	return (
		<div className="admin">
			<div className="mb-3">
				<div className="d-flex justify-content-between align-items-center">
					<div>
						<span
							style={{
								fontWeight: "600",
								textTransform: "capitalize",
								color: "#000",
							}}>
							{Translate[lang].zones}
						</span>
					</div>
					<div className="add-admin">
						{canAdd("zone") && (
							<Button
								variant="primary"
								className="me-2 h-75"
								onClick={() => {
									navigate("/add-zone");
								}}>
								<i
									className={`la la-plus ${lang === "en" ? "mr-2" : "ml-2"}`}></i>
								{Translate[lang]?.add} {Translate[lang]?.zone}
							</Button>
						)}
					</div>
				</div>
			</div>

			<div>
				<div className={`${hasData === 0 ? "text-center" : "table-style"}`}>
					{loading && (
						<div style={{ height: "300px" }}>
							<Loader />
						</div>
					)}
					{hasData === 1 && !loading && (
						<Table responsive>
							<thead>
								<tr>
									<th>
										<strong>{Translate[lang]?.name}</strong>
									</th>
									<th>
										<strong>{Translate[lang]?.price_per}</strong>
									</th>
									<th>
										<strong>{Translate[lang]?.price}</strong>
									</th>
									<th>
										<strong>{Translate[lang]?.quick_valet_price}</strong>
									</th>

									<th>
										<strong>{Translate[lang]?.government}</strong>
									</th>
									<th>
										<strong>{Translate[lang]?.area}</strong>
									</th>
									<th>
										<strong>{Translate[lang]?.block}</strong>
									</th>
									<th>
										<strong>{Translate[lang]?.street}</strong>
									</th>
									<th>
										<strong>{Translate[lang]?.location}</strong>
									</th>
									<th>
										<strong>{Translate[lang]?.floor}</strong>
									</th>
									<th>
										<strong>{Translate[lang]?.assigned_staff}</strong>
									</th>
									<th>
										<strong>
											{Translate[lang]?.number_of_available_parking}
										</strong>
									</th>
									<th>
										<strong>{Translate[lang]?.action}</strong>
									</th>
								</tr>
							</thead>
							<tbody>
								{admins?.length > 0 &&
									admins?.map((item, index) => {
										return (
											<CardItem
												key={index}
												index={index}
												item={item}
												setShouldUpdate={setShouldUpdate}
											/>
										);
									})}
							</tbody>
						</Table>
					)}
					{hasData === 0 && <NoData />}
					<Pagination
						setData={setAdmins}
						service={zoneService}
						shouldUpdate={shouldUpdate}
						setHasData={setHasData}
						setLoading={setLoading}
						search={search}
					/>
				</div>
			</div>
		</div>
	);
};
export default Zones;
